import { RootState } from 'types/root';
import {
  AddAndPayRazorpayStep1Resp,
  AddAndPayRazorpayStep2Resp,
  AddRazorpayStep1Resp,
  AddRazorpayStep2Resp,
  TransactionsRazorpayState,
  UseRazorpayResp,
} from 'types/transaction-razorpay';
import { COPAS_PAYMENT_STATUS } from 'utils/constants';

export const transactionsRazorpayTree = (state: RootState): TransactionsRazorpayState =>
  state.transactionRazorpay || {};

export const transactionsRazorpayAddPaymentIsLoading = (state: RootState): boolean =>
  transactionsRazorpayTree(state).isAddPaymentLoading || false;

export const addRazorpayStep1Resp = (state: RootState): AddRazorpayStep1Resp =>
  transactionsRazorpayTree(state).addRazorpayStep1Resp || {};

export const addRazorpayStep2Resp = (state: RootState): AddRazorpayStep2Resp =>
  transactionsRazorpayTree(state).addRazorpayStep2Resp || {};

export const addAndPayRazorpayStep1Resp = (state: RootState): AddAndPayRazorpayStep1Resp =>
  transactionsRazorpayTree(state).addAndPayRazorpayStep1Resp || {};

export const addAndPayRazorpayStep2Resp = (state: RootState): AddAndPayRazorpayStep2Resp =>
  transactionsRazorpayTree(state).addAndPayRazorpayStep2Resp || {};

export const useRazorpayIsLoading = (state: RootState): boolean =>
  transactionsRazorpayTree(state).isUsePaymentLoading || false;

export const useRazorpayResp = (state: RootState): UseRazorpayResp =>
  transactionsRazorpayTree(state).useRazorPayResp || {};

export const razorPayIsFailed = (state: RootState): boolean =>
  useRazorpayResp(state).status === COPAS_PAYMENT_STATUS.FAILED ||
  addAndPayRazorpayStep2Resp(state).status === COPAS_PAYMENT_STATUS.FAILED ||
  false;

export const razorPayIsSuccess = (state: RootState): boolean =>
  useRazorpayResp(state).status === COPAS_PAYMENT_STATUS.SUCCESS ||
  addAndPayRazorpayStep2Resp(state).status === COPAS_PAYMENT_STATUS.SUCCESS ||
  false;

export const razorPayIsPending = (state: RootState): boolean =>
  useRazorpayResp(state).status === COPAS_PAYMENT_STATUS.PENDING ||
  addAndPayRazorpayStep2Resp(state).status === COPAS_PAYMENT_STATUS.PENDING ||
  false;
